import { render } from "./RouteYTD.vue?vue&type=template&id=fa10f20a"
import script from "./RouteYTD.vue?vue&type=script&lang=js"
export * from "./RouteYTD.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__